import React from "react";
import MDTypography from "../components/MDTypography";


export default function OthelloPrimary(props) {
    
    return (<MDTypography color="primary" fontWeight="light" fontSize={15}>{props.children}</MDTypography>);
}

